import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { IGeoLocationGetMyLocationResponse } from '../../entity/interface/iGeoLocation';
import { IGetMyLocationUseCase } from '../../core/usecases/geoLocation/GetMyLocationUseCase';

export interface IGeoLocationService {
    getMyLocation(): Promise<IGeoLocationGetMyLocationResponse>;
}

export class GeoLocationService implements IGeoLocationService {
    // Lazy getter for dependency to avoid circular dependencies
    private get geoLocationUseCase(): IGetMyLocationUseCase {
        return container.resolve<IGetMyLocationUseCase>(DI.USECASES.IGetMyLocationUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    /**
     * get my geo location
     * @returns {Promise<IGeoLocationGetMyLocationResponse>}
     */
    async getMyLocation(): Promise<IGeoLocationGetMyLocationResponse> {
        return await this.geoLocationUseCase.execute();
    }
}
